import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import Routes from "./Routes";
import RootWrapper from "./components/root/RootWrapper";
import { Toaster } from "sonner";
import ErrorBoundary from "./components/error/ErrorBoundary";

// @slava - added an error handler
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <BrowserRouter>
    <RootWrapper>
      <ErrorBoundary>
        <Toaster />
        <Routes />
      </ErrorBoundary>
    </RootWrapper>
  </BrowserRouter>
);
